import { useState, useEffect } from "react";
import "../Navbar/hnavbar.css";
import companyLogo from "../../Assets/LOGO1.png";
import { NavLink } from "react-router-dom";


function HNavbar() {
    const [navOpen, setNavOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = navOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [navOpen]);

    return (
        <>
            {/* ===== NAVBAR ===== */}
            <nav className="sb-navbar navbar navbar-expand-lg">
                <div className="container">
                    <a className="navbar-brand d-flex align-items-center" href="/">
                        <img
                            src={companyLogo}
                            alt="Sound Barrier"
                            className="main-logo"
                        />
                    </a>

                    {/* Hamburger toggler — shows only on mobile/tablet */}
                    <button
                        className="sb-toggler d-lg-none"
                        type="button"
                        onClick={() => setNavOpen((v) => !v)}
                        aria-label="Toggle navigation"
                    >
                        <i className="fa fa-bars fa-lg"></i>
                    </button>

                    {/* Desktop nav — hidden on mobile */}
                    <div className="collapse navbar-collapse d-none d-lg-flex">
                        <ul className="navbar-nav mx-auto align-items-center gap-1">
                            <NavLink
                                to="/"
                                end
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Home
                            </NavLink>

                            <NavLink
                                to="/products"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Products
                            </NavLink>

                            <NavLink
                                to="/application"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Applications
                            </NavLink>

                            <NavLink
                                to="/projects"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Projects
                            </NavLink>

                            <NavLink
                                to="/technology"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Technology
                            </NavLink>

                            <NavLink
                                to="/resources"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Resources
                            </NavLink>

                            <NavLink
                                to="/aboutus"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                About Us
                            </NavLink>

                            {/* <NavLink
                                to="/contact"
                                className={({ isActive }) =>
                                    `nav-link sb-nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                Contact Us
                            </NavLink> */}
                        </ul>
                        <a href="/contactus" className="btn2 btn2-request-quote ms-3 d-inline-flex align-items-center gap-2">
                            Contact Us&nbsp;<i className="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </nav>

            {/* ===== MOBILE SIDEBAR OVERLAY ===== */}
            {navOpen && (
                <div className="sb-sidebar-overlay" onClick={() => setNavOpen(false)}></div>
            )}

            {/* ===== MOBILE SIDEBAR ===== */}
            <div className={`sb-sidebar d-lg-none ${navOpen ? "sb-sidebar-open" : ""}`}>
                {/* Header */}
                <div className="sb-sidebar-header">
                    <div className="d-flex align-items-center gap-2">
                        {/* <img
                            src={companyLogo}
                            alt="Sound Barrier"
                            className="sidebar-logo"
                        /> */}
                    </div>
                    <button className="sb-sidebar-close" onClick={() => setNavOpen(false)} aria-label="Close">
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                {/* Nav links */}
                <nav className="sb-sidebar-nav">
                    <NavLink
                        to="/"
                        end
                        onClick={() => setNavOpen(false)}
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-home"></i> Home
                    </NavLink>

                    <NavLink
                        to="/products"
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-solid fa-bookmark"></i> Products
                    </NavLink>

                    <NavLink
                        to="/application"
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-tasks"></i> Applications
                    </NavLink>

                    <NavLink
                        to="/projects"
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-folder-open"></i> Projects
                    </NavLink>
                    <NavLink
                        to="/technology"
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-solid fa-gears"></i> Technology
                    </NavLink>

                    <NavLink
                        to="/resources"
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-solid fa-book"></i> Resources
                    </NavLink>

                    <NavLink
                        to="/aboutus"
                        onClick={() => setNavOpen(false)}
                        className={({ isActive }) =>
                            `sb-sidebar-link ${isActive ? "active" : ""}`
                        }
                    >
                        <i className="fa fa-info-circle"></i> About Us
                    </NavLink>

                </nav>

                {/* CTA Buttons */}
                <div className="sb-sidebar-footer">
                    <NavLink to="/contactus" className="btn2 btn2-orange w-100 d-flex align-items-center justify-content-center gap-2">
                        Contact Us&nbsp;<i className="fa fa-arrow-right"></i>
                    </NavLink>
                    <NavLink to="/brochure" className="btn2 btn2-outline-dark-sb w-100 d-flex align-items-center justify-content-center gap-2 mt-2">
                        DOWNLOAD BROCHURE&nbsp;<i className="fa fa-download"></i>
                    </NavLink>
                </div>
            </div>
        </>
    )
}

export default HNavbar